// < !DOCTYPE html >
// <html>
// <head>
// <meta charset="UTF-8">
// <meta http-equiv="X-UA-Compatible" content="IE=edge"/>
// <meta name="viewport" content="maximum-scale=1.0,minimum-scale=1.0,user-scalable=0,width=device-width,initial-scale=1.0"/>
// <title>信息流JS代码示例</title>
// </head>
// <body>
//     <div id="container"></div>
// </body>
// </html>
// <script src="//static.mediav.com/js/feed_ts.js"></script>
// <script>
// // 参数说明：
// // 1. w: 广告宽度
// // 2. showid: 根据需要填写测试showid或正式showid
// // 3. placeholderId: 广告所在容器id，不填则在NEWS_FEED方法调用位置创建广告
// // 5. inject: 一般情况下默认为‘cads’即可
// NEWS_FEED({
//     w: 665,
//     placeholderId: 'container', // 指定插入位置
//     showid: 'dujNK0', // 需要替换showid
//     inject: 'cads',
// //  noCSS: true, //是否不加载默认css， 默认为false（加载默认css）。
//     pureAdNum: 3, //一次请求的广告条数，建议值设置为 N 或 N+1 （N为一屏所容纳的广告条数）
//     useCapture: true,
// //  displayType: 'singleImage', //固定单图样式展现
// //  onFailSign: 'test', //媒体可自定义属性和值，用作本次加载的标记
// //  userConf: { //前端样式配置，按需使用
//             //      titleFontSize: 14,
//             //      titleFontColor: "#34c75f",
//             //      titleHover: "#f00",
//             //      titleFontFamily: "Microsoft Yahei",
//             //      contentBackground: "#a69898"
//             //  },
//             onFail: function(param){ //广告加载失败时触发的回调（仅在函数调用触发了请求时才能响应onFail）
//             /*param：参数为NEWS_FEED调用时的入参*/
//             console.log(param, '广告加载失败时触发了回调');
//     }
// });
// // feed_ts.js 引用一次即可，里面定义了NEWS_FEED方法。
// // NEWS_FEED方法可重复调用，每调用一次即加载一条广告。（最多支持同时 {{ pureAdNum }} 条广告处于加载中状态）
//     // 屏蔽中参数可按需放开使用 
//     </script>

import JsLoader from "If_AdTool/common/JsLoader";
import getScriptUrl from "./getScriptUrl";
import Elshow from "If_AdTool/common/Elshow";
var elShow = new Elshow(200, 200);
export default function i360Ad(adData, el) {
    let { data360:{type="banner"} } = adData;
    if (type =="banner"){
        let { load360Lib = false } = window.IfengAmgr;
        if (!load360Lib) {
            JsLoader("//static.mediav.com/js/feed_ts.js", () => {
                window.IfengAmgr.load360Lib = true;
                load360Ad(adData, el);
            })
        } else {
            load360Ad(adData, el);
        }
    }
    if (type == "json") {
        let { data360: { data, script, callback }, closeFn } = adData;
        let scriptUrl = getScriptUrl(script, callback);
        JsLoader(scriptUrl, () => {
            //回调
            let div = document.createElement("div");
            let constentEl = document.createElement("div");
            let id = "_" + Math.random().toString(36).slice(2);
            constentEl.id = id;
            el.appendChild(div);
            div.appendChild(constentEl);
            data.nullCallback = function(){
                div.innerHTML = "";
                el.removeChild(div);
                closeFn && closeFn();
            } 
            window.IfengAmgr.tplLib[callback].render(data, constentEl);
            add360Tag(div);
        }, () => {
            closeFn && closeFn();
        });
    }
   
}
function add360Tag(el){
    let span = document.createElement("span");
    el.style.position = "relative";
    el.appendChild(span);
    span.innerHTML = "360";
    el.a360Tag = span;
    span.style.cssText = `font-size:12px;
            padding:1px;
            line-height:1;
            position: absolute;
            left: 0px;
            bottom: 0px;
            z-index: 2;
            opacity: 0.5;
            color: #fff;
            background-color: rgba(0,0,0,.4);
            transform:scale(.7);`;
    
}
function retryOne360Ad(adData, el) {
    //同一个el，
    //
}
function loadOne360Ad(el, adData) {
    let {
        data360,//百度 tuid
        w="",
        h="",
        closeFn = null,
        renderOk =null,
        hasAdTag = true//是否需要360的广告标签
    } = adData;
    let div = document.createElement("div");
    let constentEl = document.createElement("div");
    let id = "_" + Math.random().toString(36).slice(2);
    constentEl.id = id;
    data360.placeholderId = id;
    if (w && data360.w==''){
        data360.w =w;
    }
    if (h && data360.h == '') {
        data360.h = h;
    }

    el.appendChild(div);
    div.appendChild(constentEl);
    div.style.position = "relative";
    div.style.height = data360.h +"px";
    add360Tag(div);

    data360.onFail= function(param) { //广告加载失败时触发的回调（仅在函数调用触发了请求时才能响应onFail）
        /*param：参数为NEWS_FEED调用时的入参*/
        console.log(param);
        div.innerHTML ="";
        el.removeChild(div);
        if (el.parentNode&&el.parentNode.children.length == 1) {
            el.parentNode.style.display = "none";
        }
        closeFn && closeFn();
       // this.retryOne360Ad()
    }
    data360.onSuccess = function (param) { //广告加载失败时触发的回调（仅在函数调用触发了请求时才能响应onFail）
       if (!hasAdTag){
           let adTag = div.querySelector(".adTag");
           if (adTag){
               adTag.style.display = "none"
           }
       }
       renderOk && renderOk(div)
    }
    NEWS_FEED(data360);
}
function load360Ad(adData, el) {
        let {
        visibleRender = false
    } = adData;
    if (visibleRender) {
        elShow.listenerScroll(el, () => {
            loadOne360Ad(el,adData);
        })
    } else {
        loadOne360Ad(el,adData);
    }
}